import {useSelector} from "react-redux";
import {AppRootStateType} from "../../state/store.ts";
import {ITransferCampaignResponseData} from "../../state/models/TransferCampaignResponse.ts";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {
    updateStatusCurrentTransferCampaignTC
} from "../../state/reducers/transferCampaign-reducer.ts";
import {useAppDispatch} from "../useAppDispatch.ts";
import {useModalClose} from "../modal/useCloseModal.ts";
import {useTranslation} from "react-i18next";
import {appActions} from "../../state/reducers/app-reducer.ts";

const useLaunchCampaignModal = ({modalId}: {
    modalId: string
}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const closeManually = useModalClose(modalId);
    const isLoading = useSelector<AppRootStateType, boolean>(state => state.transferCampaigns.isLoading);
    const data = useSelector<AppRootStateType, ITransferCampaignResponseData | null>(state => state.transferCampaigns.data);
    const {t} = useTranslation();

    const navigateToSettings = () => {
        navigate("/transfer_campaign_settings")
    }
    const [categoryTitle, setCategoryTitle] = useState('')

    const selectCategory = (mode: "no_adult" | "custom" | "all") => {
        switch (mode) {
            case 'all': {
                return setCategoryTitle(t('pages.channelInfo.transferTrafficFilter.statisticsTable.customValues.categories_all'))
            }
            case "custom": {
                return setCategoryTitle(t('pages.channelInfo.transferTrafficFilter.statisticsTable.customValues.categories_custom'))
            }
            case "no_adult": {
                return setCategoryTitle(t('pages.channelInfo.transferTrafficFilter.statisticsTable.customValues.categories_noAdult'))
            }
        }
    }

    useEffect(() => {
        if (data) {
            selectCategory(data?.campaign_category_mode)
        }
    }, []);
    const conditionPermission = !data?.channel?.bot_added || !data?.channel?.bot_permission_edit || !data?.channel?.bot_permission_invite || !data?.channel?.bot_permission_delete || !data?.channel?.bot_permission_post


    const changeCampaignStatus = async () => {
        if (conditionPermission) {
            console.log('permission нет')
            dispatch(appActions.setRedirectFlag("transfer"))
            closeManually()
            navigate('/addChannel_step2')
        } else {
            if (data && data.status === 'disabled') {
                await dispatch(updateStatusCurrentTransferCampaignTC(data?.id, {status: "enabled"}, t('pages.channelInfo.transferTrafficFilter.confirmModal.confirmState.successResponse'), t('pages.channelInfo.transferTrafficFilter.confirmModal.confirmState.errorResponse')));
                closeManually()
            } else if (data && data.status === 'enabled') {
                await dispatch(updateStatusCurrentTransferCampaignTC(data?.id, {status: "disabled"}, t('pages.channelInfo.transferTrafficFilter.confirmModal.declineState.successResponse'), t('pages.channelInfo.transferTrafficFilter.confirmModal.declineState.errorResponse')));
                closeManually()
            }
        }
    }

    return {
        isLoading, data, navigateToSettings, categoryTitle, changeCampaignStatus
    }
}
export default useLaunchCampaignModal;